import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Input,
    Label,
    Form,
} from "reactstrap";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import { useToast } from "../../Components/Common/ToastContext";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { getAppVersionById, updateAppVersion } from "./_requests";

const EditAppVersion = () => {
    document.title = "App Version Edit | Paal Dappa";
    const { showToast } = useToast();
    const navigate = useNavigate();
    const { id } = useParams();
    const [appVersion, setAppVersion] = useState<any>(null);

    const user = JSON.parse(localStorage.getItem("authUser") || "{}");

    useEffect(() => {
        if (id) {
            getAppVersionById(id).then((res: any) => {
                // Handle variations of API response wrappers
                const data = res?.data || res || {};
                // If data is an array (which might happen if getAppVersionById wasn't precise), try to find by ID, else just set.
                if (Array.isArray(data)) {
                    const found = data.find((item: any) => item.id.toString() === id.toString());
                    if (found) setAppVersion(found);
                    else setAppVersion(data[0]);
                } else {
                    setAppVersion(data);
                }
            });
        }
    }, [id]);

    const validation: any = useFormik({
        enableReinitialize: true,

        initialValues: {
            app_type: appVersion?.app_type || "",
            platform: appVersion?.platform || "",
            min_version: appVersion?.min_version || "",
            latest_version: appVersion?.latest_version || "",
            update_message: appVersion?.update_message || "",
            force_update: appVersion?.force_update === 1,
            store_url: appVersion?.store_url || "",
            status: appVersion?.status === 1,
            created_by: user?.id || user?.userId,
            updated_by: user?.id || user?.userId,
        },

        onSubmit: async (values) => {

            const data = {
                app_type: values.app_type,
                platform: values.platform,
                min_version: values.min_version,
                latest_version: values.latest_version,
                update_message: values.update_message,
                force_update: values.force_update ? 1 : 0,
                store_url: values.store_url,
                status: values.status ? 1 : 0,
                created_by: user?.id || user?.userId,
                updated_by: user?.id || user?.userId,
            };
            console.log("===========", data);
            try {
                const res: any = await updateAppVersion(id, data);
                if (res.status === true || res.data?.status === true) {
                    toast.success(res.message || res.data?.message || "App Version updated successfully", { autoClose: 3000 });
                    validation.resetForm();
                    navigate("/settings", { state: { activeTab: "6" } });
                } else {
                    toast.error(res.message || res.data?.message || "Failed to update App Version", { autoClose: 3000 });
                }
            } catch (error: any) {
                toast.error(error.message || "An error occurred", { autoClose: 3000 });
            }
        },
    });

    return (
        <div className="page-content">
            <ToastContainer closeButton={false} limit={1} />
            <Container fluid>
                <BreadCrumb title="Edit App Version" pageTitle="Settings" />

                <Form
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                >
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="fw-bold">App Type</Label>
                                                <Input
                                                    name="app_type"
                                                    type="select"
                                                    className="form-select bg-light"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.app_type || ""}
                                                    disabled
                                                >
                                                    <option value="">Select App Type</option>
                                                    <option value={1}>User App</option>
                                                    <option value={2}>Driver App</option>
                                                </Input>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="fw-bold">Platform</Label>
                                                <Input
                                                    name="platform"
                                                    type="select"
                                                    className="form-select bg-light"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.platform || ""}
                                                    disabled
                                                >
                                                    <option value="">Select Platform</option>
                                                    <option value={1}>Android</option>
                                                    <option value={2}>iOS</option>
                                                </Input>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="fw-bold">Min Version</Label>
                                                <Input
                                                    name="min_version"
                                                    type="text"
                                                    className="form-control"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.min_version || ""}
                                                    placeholder="e.g. 1.0.0"
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="fw-bold">Latest Version</Label>
                                                <Input
                                                    name="latest_version"
                                                    type="text"
                                                    className="form-control"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.latest_version || ""}
                                                    placeholder="e.g. 1.0.3"
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="fw-bold">Store URL</Label>
                                                <Input
                                                    name="store_url"
                                                    type="text"
                                                    className="form-control"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.store_url || ""}
                                                    placeholder="e.g. https://play.google.com/store/apps/details?id=com.example"
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="d-flex align-items-center h-100 mt-2 gap-5">
                                                <div className="d-flex align-items-center">
                                                    <Label className="fw-bold me-3 mb-0">Force Update</Label>
                                                    <div className="form-check form-switch form-switch-lg mb-0" dir="ltr">
                                                        <Input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="force_update_switch"
                                                            name="force_update"
                                                            checked={validation.values.force_update}
                                                            onChange={(e) => {
                                                                validation.setFieldValue("force_update", e.target.checked);
                                                            }}
                                                        />
                                                        <Label className="form-check-label" htmlFor="force_update_switch">
                                                            {validation.values.force_update ? "Enabled" : "Disabled"}
                                                        </Label>
                                                    </div>
                                                </div>

                                                <div className="d-flex align-items-center">
                                                    <Label className="fw-bold me-3 mb-0">Status</Label>
                                                    <div className="form-check form-switch form-switch-lg mb-0" dir="ltr">
                                                        <Input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="status_switch"
                                                            name="status"
                                                            checked={validation.values.status}
                                                            onChange={(e) => {
                                                                validation.setFieldValue("status", e.target.checked);
                                                            }}
                                                        />
                                                        <Label className="form-check-label" htmlFor="status_switch">
                                                            {validation.values.status ? "Active" : "Inactive"}
                                                        </Label>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <Label className="fw-bold">Update Message</Label>
                                                <Input
                                                    name="update_message"
                                                    type="textarea"
                                                    className="form-control"
                                                    rows="3"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.update_message || ""}
                                                    placeholder="Please update to the latest version..."
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <div className="text-end mb-3">
                        <Link to="/settings" className="btn btn-secondary w-sm me-2">
                            Cancel
                        </Link>
                        <button type="submit" className="btn btn-success w-sm">
                            Submit
                        </button>
                    </div>
                </Form>
            </Container>
        </div>
    );
};

export default EditAppVersion;
